import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Injectable,
    Input,
    LOCALE_ID,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import {
    CalendarUtils,
    CalendarWeekViewComponent,
    DateAdapter,
    getWeekViewPeriod,
} from 'angular-calendar';
import {
    WeekView,
    GetWeekViewArgs,
    WeekViewTimeEvent,
    EventColor,
    CalendarEvent,
    WeekViewAllDayEventRow,
    WeekViewAllDayEvent,
} from 'calendar-utils';
import { DragEndEvent, DragMoveEvent } from 'angular-draggable-droppable';
import {EmployeeScheduleDialogComponent} from "./dialog/employeeScheduleDialog.component";
import {MatDialog} from "@angular/material/dialog";

export interface User {
    id: string;
    name: string;
}

interface DayViewScheduler extends WeekView {
    users: User[];
}

interface GetWeekViewArgsWithUsers extends GetWeekViewArgs {
    users: User[];
}

@Injectable()
export class DayViewSchedulerCalendarUtils extends CalendarUtils {
    getWeekView(args: GetWeekViewArgsWithUsers): DayViewScheduler {
        const { period } = super.getWeekView(args);
        const view: DayViewScheduler = {
            period,
            allDayEventRows: [],
            hourColumns: [],
            users: [...args.users],
        };

        view.users.forEach((user, columnIndex) => {
            const events = args.events.filter(
                (event) => event.meta.user.id === user.id
            );
            const columnView = super.getWeekView({
                ...args,
                events,
            });
            view.hourColumns.push(columnView.hourColumns[0]);
            columnView.allDayEventRows.forEach(({ row }, rowIndex) => {
                view.allDayEventRows[rowIndex] = view.allDayEventRows[rowIndex] || {
                    row: [],
                };
                view.allDayEventRows[rowIndex].row.push({
                    ...row[0],
                    offset: columnIndex,
                    span: 1,
                });
            });
        });

        return view;
    }
}

@Component({
    // tslint:disable-line max-classes-per-file
    selector: 'week-view-scheduler',
    templateUrl: 'week-view-scheduler.component.html',
    providers: [DayViewSchedulerCalendarUtils],
})
export class WeekViewSchedulerComponent extends CalendarWeekViewComponent {
    private _users: User[] = [];
    private _allUsers: User[] = [];
    dialogRef: any;

    private schedule: any;

    trackByUserId = (index: number, row: User) => row.id;

    @Output() sectionClicked = new EventEmitter();

    @Input()
    set users(users: User[]) {
        this._users = [];
        this._allUsers = users;

        for (let i=0; i<users.length; i++) {

            this._users.push(users[i])
        }

        this.refreshBody();
        this.emitBeforeViewRender();

        // console.log(this.view.hourColumns);
    }

    get users(): User[] {
        return this._users;
    }

    onClick(data: any) {

        this.sectionClicked.emit(data);
    }
}
